import { initWebWorker } from './components/worker-handler'
import initRateCalculator from './components/currency-rate-calculator'
import { initActualOffers } from './components/handle-actual-offers'
import { initExitPopup } from './components/notification-popup'
import { initNotoficationService } from './components/notification-slider'
import { initHelpTip } from './components/handle-featured-rates-update'
import { initSubmenuObserver } from './components/sticky-submenu-service'
import currencyChart from './components/currency-chart'
import { initI18n } from 'i18n/i18n'

declare let SINGLE_RATE_BASE_CURRENCY: string
declare let SINGLE_RATE_COUNTER_CURRENCY: string

const $rateCalculator = document.querySelector<HTMLTableSectionElement>('.currency-rate-calculator')

initWebWorker(SINGLE_RATE_BASE_CURRENCY, SINGLE_RATE_COUNTER_CURRENCY)
if ($rateCalculator) initRateCalculator()
initActualOffers()
initExitPopup()
initNotoficationService()
initHelpTip()
initSubmenuObserver()

initI18n().then(() => {
  currencyChart.init({
    baseCurrency: SINGLE_RATE_BASE_CURRENCY,
    counterCurrency: SINGLE_RATE_COUNTER_CURRENCY,
  })
})
